export const keyRole = 'https://contenta360.com/roles/roles';

export const ROLES = {
  ADMIN: 'ADMIN',
  ADVISOR: 'ADVISOR',
  APPROVED_ADVISOR: 'APPROVED_ADVISOR',
  USER: 'TRAVELER',
  USER_TRAVELER: 'TRAVELER',
  MASTER: 'MASTER',
  BOOKING_AGENT: 'BOOKING_AGENT',
  FINANCE: 'FINANCE',
};

export function isUserAdmin(userRole) {
  if (!userRole) return false;
  return userRole === ROLES.ADMIN;
}

export function isUserGuide(userRole) {
  if (!userRole) return false;
  return userRole === ROLES.ADVISOR;
}

export function isUserTraveller(userRole) {
  if (!userRole) return false;
  return userRole === ROLES.USER || userRole === ROLES.USER_TRAVELER;
}

export function isUserMaster(userRole) {
  if (!userRole) return false;
  return userRole === ROLES.MASTER;
}

export function canViewAdmin(user) {
  const roles = user?.[keyRole] || [];
  return roles.includes(ROLES.ADMIN);
}

export function canViewGuide(user) {
  const roles = user?.[keyRole] || [];
  return roles.includes(ROLES.ADVISOR);
}

export function canViewUser(user) {
  const roles = user?.[keyRole] || [];
  return roles.includes(ROLES.USER) || roles.includes(ROLES.USER_TRAVELER);
}

export function canViewMaster(user) {
  const roles = user?.[keyRole] || [];
  return roles.includes(ROLES.MASTER);
}

export function isUserBookingAgent(userRole) {
  if (!userRole) return false;
  return userRole === ROLES.BOOKING_AGENT;
}

export function canViewBookingAgent(user) {
  const roles = user?.[keyRole] || [];
  return roles.includes(ROLES.BOOKING_AGENT);
}

export function canViewFinance(user) {
  const roles = user?.[keyRole] || [];
  return roles.includes(ROLES.FINANCE);
}

/** Any organization member, including FINANCE, which has no portal screen yet. */
export function isB2BUser(user) {
  const roles = user?.[keyRole] || [];
  return (
    roles.includes(ROLES.MASTER) ||
    roles.includes(ROLES.BOOKING_AGENT) ||
    roles.includes(ROLES.FINANCE)
  );
}
